let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9EFuZ")).then(() => parcelRequire('a2rPn'));